import { IProjectCompany } from '@company/projectCompany/projectCompany.models';
import { IProjectTeam } from '@projectTeam/projectTeam.models';
import { IProjectRoleOption } from '@role/projectRole/projectRole.models';
import { IUserInfo } from '@user/user.models';
import { IProjectUserProfileBase } from '@userProfile/projectUserProfile.models';
import { IUserProfileBase } from '@userProfile/userProfile.models';

export enum EMemberFormKeys {
  USER_SEARCH_KEYWORD = 'userSearchKeyword',
  IS_EXTERNAL = 'isExternal',
  TEL = 'tel',
  TEAMS = 'teams',
  ROLES = 'roles',
  COMPANY = 'company',
  USER_PROFILE = 'userProfile',
  PROJECT_USER_PROFILE = 'projectUserProfile',
  USER_PROFILE_ID = 'userProfileId',
  USER_INFO = 'userInfo',
}

export interface IMemberFormState {
  [EMemberFormKeys.TEL]: string | null;
  [EMemberFormKeys.COMPANY]: IProjectCompany | null;
  [EMemberFormKeys.TEAMS]: IProjectTeam[];
  [EMemberFormKeys.ROLES]: IProjectRoleOption[];
  [EMemberFormKeys.PROJECT_USER_PROFILE]: IProjectUserProfileBase | null;
  [EMemberFormKeys.IS_EXTERNAL]: boolean;
  [EMemberFormKeys.USER_PROFILE]: IUserProfileBase | null;
  [EMemberFormKeys.USER_INFO]: IUserInfo | null;
  [EMemberFormKeys.USER_SEARCH_KEYWORD]: string | null;
}
